/**
 * Demo sandbox "viewing as" bar (docs/features/demo-sandbox/plan.md §4.4): shown while the prospect
 * is signed in as a seeded persona, in the staff app and in the family portal.
 */
import React from 'react';
import { getActivePersona } from '../../utils/sandbox';
import { backToOwner } from '../../services/demo/personaSwitch';

const PersonaBar: React.FC = () => {
  const persona = getActivePersona();
  if (!persona) return null;
  return (
    <div className="flex flex-wrap items-center justify-center gap-x-3 gap-y-1 bg-violet-700 px-4 py-1.5 text-sm text-white" role="status" data-testid="persona-bar">
      <span>
        Sandbox: viewing as <span className="font-semibold">{persona.name || persona.key}</span>
        {persona.title ? `, ${persona.title}` : ''}. Sample data only; never enter real patient information.
      </span>
      <button type="button" onClick={() => backToOwner()} className="rounded bg-white/15 px-2 py-0.5 font-medium hover:bg-white/25">
        Back to my account
      </button>
    </div>
  );
};

export default PersonaBar;
